module.exports = __webpack_public_path__ + "img/spring-hill-logo.64169678.jpg";